import svgIcons from '@/assets/svg/icons';
import CustomButton from '@/components/atoms/CustomButton';
import authRoutes from '@/constants/routes/auth';
import sharedRoutes from '@/constants/routes/shared';
import { useAuthContext } from '@/context/auth/useAuthContext';
import authMessages from '@/messages/auth';
import menuMessages from '@/messages/menu';
import colors from '@/theme/colors';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
  useDisclosure,
  VStack,
  Link as ChakraLink,
  HStack,
  Text,
} from '@chakra-ui/react';
import { Link, useRouter } from '@tanstack/react-router';
import React from 'react';

export type TMenuOption = {
  label: string;
  navigateTo: string;
};

const menuOptions = [
  {
    label: authMessages.signIn,
    navigateTo: authRoutes.signIn,
  },
  {
    label: menuMessages.contactSupport,
    navigateTo: sharedRoutes.contactSupport,
  },
];

const MobileDropdownMenu = () => {
  const { isAuthenticated, signOut } = useAuthContext();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const {
    state: {
      location: { pathname },
    },
    navigate,
  } = useRouter();

  const handleSignOut = () => {
    signOut();

    navigate({
      to: '/sign-in',
    });
  };

  return (
    <Popover
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onClose}
      placement={'bottom'}
      closeOnBlur={true}
      returnFocusOnClose={false}
    >
      <PopoverTrigger>
        <CustomButton
          isTransparent
          iconBeforeLabelSvgPath={svgIcons.hamburgerMenu}
          iconBeforeLabelSvgColor={colors.text.darkBlue}
          iconAfterLabelSvgSize={20}
          labelStyle={{ margin: 0 }}
        />
      </PopoverTrigger>
      <PopoverContent
        bg="white"
        width={'200px'}
        border={0}
        top={-2}
        right={5}
        borderRadius={'8px'}
        boxShadow={'0px 6px 12px 0px #0E006224'}
      >
        <VStack padding={'20px'} alignItems={'flex-end'}>
          {menuOptions.map((option, index) => {
            const isActiveRoute = pathname === option.navigateTo;
            return (
              <ChakraLink
                as={Link}
                key={`${index}-${option.label}`}
                onClickCapture={onClose}
                to={option.navigateTo}
                textAlign={'right'}
                fontWeight={'600'}
                color={isActiveRoute ? 'primary.500' : 'text.mediumBlue'}
              >
                {option.label}
              </ChakraLink>
            );
          })}

          {isAuthenticated && (
            <HStack _hover={{ cursor: 'pointer' }} onClick={handleSignOut}>
              <Text color={'text.mediumGray'} fontWeight={'600'}>
                {menuMessages.signOut}
              </Text>
            </HStack>
          )}
        </VStack>
      </PopoverContent>
    </Popover>
  );
};

export default MobileDropdownMenu;
